<main>
    <section class="container customer-container">
        <div class="col-xs-12 text-center m-t-30">
            <h1 class="error-text">Something Went Wrong !!!</h1>
        </div>
    </section>
</main>